import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { skeletonClasses, Skeleton } from '@mui/material';
var _excluded = ["animation", "height", "sx"];
var styles = {
  skeletonLoaderRoot: _defineProperty({
    marginBottom: 0.5
  }, "&.".concat(skeletonClasses['wave'], ":after"), {
    background: 'linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.12), transparent)'
  })
};

var SkeletonLoader = function SkeletonLoader(_ref) {
  var _ref$animation = _ref.animation,
      animation = _ref$animation === void 0 ? 'wave' : _ref$animation,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 10 : _ref$height,
      sx = _ref.sx,
      rest = _objectWithoutProperties(_ref, _excluded);

  var skeletonLoaderRoot = styles.skeletonLoaderRoot;
  return /*#__PURE__*/React.createElement(Skeleton, _extends({
    sx: [skeletonLoaderRoot, sx],
    animation: animation,
    height: height
  }, rest));
};

SkeletonLoader.displayName = 'SkeletonLoader';
export { SkeletonLoader };